import {useState} from 'react'
import { Controller } from 'react-hook-form';
import { Box, CircularProgress, Container, Grid, Typography, FormControl, MenuItem, Stack, styled, TextField, FormHelperText, Alert } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { CalendarPicker } from "@mui/x-date-pickers";
import moment from 'moment';
import { PickersDay } from '@mui/x-date-pickers';
import i18n from 'src/i18n/i18n';

const CustomCalendarPicker = styled(CalendarPicker)(
    (props) => 
        `.Mui-disabled {
            background: rgba(255,0,0,0.4);
        }
        .Mui-selected {
            background: rgba(39, 64, 115) !important;
        }
        .Mui-non_working_days{
            background: rgba(170, 170, 170) !important;
        }
        .Mui-past{
            color: rgba(255,0,0) !important;
            background: rgba(240, 240, 240) !important;
        }
        ${props.className != 'no-events' ? `
        .MuiPickersDay-root:not(.Mui-disabled, .Mui-selected) {
            background: rgba(122, 179, 81,0.4) !important;
        }` : ''}
    `    
);


export default function FormOne(props) {
    const [day, setDay] = useState(false);
    const t = (key: string): string => {
        return i18n.t(key);
      };

    return (
        <>
            <Container maxWidth="lg">
                <Grid item sm={12}>
                    <Typography variant="h1">
                        {
                            (() => {
                                let name = "";
                                switch (props.generalDataController.getValues('formality_id')) {
                                    case '1':
                                        name = t('HOME.FIRST_TIME');
                                        break;
                                    case '2':
                                        name = t('HOME.RENEWAL');
                                        break;
                                    case '3':
                                        name = t('HOME.EXCHANGE');
                                        break;
                                    case '4':
                                        name = t('HOME.LOST');
                                        break;
                                    case '5':
                                        name = t('HOME.STOLEN');
                                        break;
                                    case '6':
                                        name = t('HOME.FOREIGNERS');
                                        break;
                                    case '7':
                                        name = t('HOME.NON_LOCALS');
                                        break;
                                    case '8':
                                        name = t('HOME.TRANSPORT');
                                        break;
                                    default:
                                        name = '';
                                        break;
                                }
                                props.generalDataController.setValue('formality_name', name);
                                return name;
                            })()
                        }
                    </Typography>
                    <Typography sx={{ mb: 2 }} variant="h3" style={{ fontWeight: 400 }}>
                        {
                            (() => {
                                switch (props.generalDataController.getValues('formality_id')) {
                                    case '1':
                                        return t('HOME.FIRST_TIME_DESCRIPTION');
                                    case '2':
                                        return t('HOME.RENEWAL_DESCRIPTION');
                                    case '3':
                                        return t('HOME.EXCHANGE_DESCRIPTION');
                                    case '4':
                                        return t('HOME.LOST_DESCRIPTION');
                                    case '5':
                                        return t('HOME.STOLEN_DESCRIPTION');
                                    case '6':
                                        return t('HOME.FIRST_TIME_DESCRIPTION2');
                                    case '7':
                                        return t('HOME.FIRST_TIME_DESCRIPTION2');;
                                    case '8':
                                        return t('HOME.TRANSPORT_DESCRIPTION');;
                                    default:
                                        return '';
                                }
                            })()
                        }
                    </Typography>

                    {
                        (props.generalDataController.watchLicenceTypeId == 4 ||
                            props.generalDataController.watchLicenceTypeId == 5) &&
                        <Grid item sm={12} sx={{ mb: 2, mt: 2 }}>
                            <Alert severity="info" variant="outlined">
                                <Typography variant="h4" style={{ fontWeight: 500 }}>
                                    {t("HOME.SERVICE_PHONE")}
                                </Typography>
                            </Alert>
                        </Grid>
                    }
                </Grid>

                <Grid container direction="row" spacing={0} columnSpacing={5} rowSpacing={0}>
                    <Grid item sm={12} xs={12} md={6}>
                        <Typography variant="h4">
                            1. {t("HOME.SELECT_LICENSE_TYPE")}:
                        </Typography>
                        <Controller
                            name="licence_type_id"
                            control={props.control}
                            defaultValue="1"
                            render={({ field }) => (
                                <TextField
                                    sx={{ mt: 2 }}
                                    fullWidth
                                    select
                                    label={t("FIELDS.LICENCE_TYPE")} {...field}
                                    onChange={(e) => {
                                        field.onChange(e);
                                      }}
                                    error={!!props.generalDataController.errors.licence_type_id}
                                    helperText={props.generalDataController.errors.licence_type_id?.message}>
                                    {
                                        props.generalDataController.selectsData.licenceTypes?.map((licenceType) => <MenuItem key={licenceType.id} value={licenceType.id}>{licenceType.name}</MenuItem>)
                                    }
                                </TextField>
                            )}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} md={6}>
                        <Typography variant="h4">
                            2. {t("HOME.SELECT_MODULE")}:
                        </Typography>
                        <Controller
                            name="module_id"
                            control={props.control}
                            render={({ field }) => (
                                <TextField
                                    sx={{ mt: 2 }}
                                    fullWidth
                                    select
                                    label={t("FIELDS.MODULE")} {...field}
                                    onChange={(e) => {
                                        field.onChange(e);
                                      }}
                                    error={!!props.generalDataController.errors.module_id}
                                    helperText={props.generalDataController.errors.module_id?.message}>
                                    {   props.generalDataController.watchLicenceTypeId == 4 || props.generalDataController.watchLicenceTypeId == 5 ?
                                            <MenuItem key={1} value={1}>CHIHUAHUA</MenuItem>
                                        : props.generalDataController.selectsData.modules?.map((module) => <MenuItem key={module.id} value={module.id}>{module.name}</MenuItem>)
                                    }
                                </TextField>
                            )}
                        />
                    </Grid>
                    {props.generalDataController.getValues('module_id') && props.generalDataController.getValues('licence_type_id') ? (
                    <Grid item xs={12} sm={12} md={6} sx={{ mt: 2 }}>
                            <Typography variant="h4" paddingTop={{ sm: 0, xs: 5 }}>
                                3. {t("HOME.SELECT_DATE")}:
                            </Typography>
                            <Grid container>
                                <Grid item xs={12} md={8} sx={{
                                    opacity: props.generalDataController.loader ? 0.5 : 1,
                                    pointerEvents: props.generalDataController.loader ? 'none' : 'auto',
                                    position: 'relative'
                                }}>
                                    {props.generalDataController.loader && (
                                        <Box sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1
                                        }}>
                                            <CircularProgress />
                                        </Box>
                                    )}
                                    <Controller
                                        name="appointment_date"
                                        control={props.control}
                                        render={({ field, field: { onChange } }) => (
                                            <FormControl fullWidth sx={{
                                                mt: 2,
                                                pointerEvents: !props.generalDataController.watchLicenceTypeId || !props.generalDataController.watchModuleId ? 'none' : 'auto'
                                            }}>
                                            <CustomCalendarPicker
                                                {...field}
                                                className={!props.generalDataController.watchLicenceTypeId || !props.generalDataController.watchModuleId ? "no-events" : ""}
                                                date={props.generalDataController.selectedCalendarDate}
                                                shouldDisableDate={(date)=>
                                                    props.generalDataController.selectsData.unavailableDays.includes(moment(date).utc().date()+"") || props.generalDataController.selectsData.nonworkingDays.includes(moment(date).utc().date()+"")
                                                }
                                                disablePast={true}
                                                renderDay={(day, selectedDays, pickersDayProps) => {
                                                    let selectedMuiClass = '';
                                                    if ( props.generalDataController.selectsData.nonworkingDays.includes( moment(day).utc().date()+"" ) )
                                                        selectedMuiClass = 'Mui-non_working_days';

                                                    if(moment(day).utc() > moment(new Date().setMonth((new Date()).getMonth() + 3)).utc())
                                                        selectedMuiClass = 'Mui-past';

                                                    if(moment().utc() > moment(day).utc())
                                                        selectedMuiClass = 'Mui-past';
                                                    return (
                                                        <PickersDay
                                                            className={ selectedMuiClass }
                                                            { ...pickersDayProps }
                                                        /> 
                                                    );
                                                }}
                                                maxDate={new Date().setMonth((new Date()).getMonth() + 3)}
                                                onYearChange={(date) => {
                                                    props.generalDataController.setSelectedCalendarDate(null);
                                                    props.generalDataController.setSelectedYear(moment(date).utc().year())
                                                }}
                                                onMonthChange={(date) => {
                                                    props.generalDataController.setSelectedCalendarDate(null);
                                                    props.generalDataController.setSelectedMonth(moment(date).utc().month() + 1);
                                                    props.generalDataController.setSelectedYear(moment(date).utc().year());
                                                }}
                                                onChange={(date) => {
                                                    props.generalDataController.setSelectedCalendarDate(date);
                                                    onChange(moment(date).utc().format('YYYY-MM-DD'));
                                                    props.generalDataController.setValue('appointment_time', '');
                                                    props.generalDataController.setSelectsData({
                                                        ...props.generalDataController.selectsData,
                                                        availableHours: props.generalDataController.selectsData.calendarDates[moment(date).utc().date()]
                                                    });
                                                    setDay(true);
                                                }}
                                            /> 
                                            <FormHelperText error={!!props.generalDataController.errors.appointment_date}>
                                                {props.generalDataController.errors.appointment_date?.message}
                                            </FormHelperText>
                                            </FormControl>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center', flexDirection: 'column' }}>
                                    <Stack direction="row" sx={{ my: 1 }}><CircleIcon sx={{ color: "#004EAA" }} /> &nbsp; {t("HOME.SELECTED")}</Stack>
                                    <Stack direction="row" sx={{ my: 1 }}><CircleIcon sx={{ color: "#7AB351" }} /> &nbsp; {t("HOME.AVAILABLE")}</Stack>
                                    <Stack direction="row" sx={{ my: 1 }}><CircleIcon sx={{ color: "#d10000" }} /> &nbsp; {t("HOME.UNAVAILABLE")}</Stack>
                                    <Stack direction="row" sx={{ my: 1 }}><CircleIcon sx={{ color: "#8A8C8E" }} /> &nbsp; {t("HOME.NO_WORKING_DAY")}</Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    ): null}
                    {props.generalDataController.getValues('appointment_date') && !props.generalDataController.loader ? (
                        <Grid item sm={12} xs={12} md={6} sx={{ mt: 2 }}>
                            <Typography variant="h4" paddingTop={{ sm: 0, xs: 5 }}>
                                4.{t("HOME.SELECT_HOUR")}:
                            </Typography>
                            <Controller
                                name="appointment_time"
                                control={props.control}
                                defaultValue="1"
                                render={({ field }) => (
                                    <TextField
                                        sx={{ mt: 2 }}
                                        fullWidth
                                        select
                                        disabled={props.generalDataController.selectsData.availableHours.length == 0}
                                        label={t("FIELDS.TIME")}
                                        {...field}
                                        error={!!props.generalDataController.errors.appointment_time}
                                        helperText={props.generalDataController.errors.appointment_time?.message}>
                                        {
                                            props.generalDataController.selectsData.availableHours
                                                .sort((a, b) => {
                                                    const [aHours, aMinutes] = a.split(':').map(Number);
                                                    const [bHours, bMinutes] = b.split(':').map(Number);
                                                    return aHours * 60 + aMinutes - (bHours * 60 + bMinutes);
                                                })
                                                .map((hour) => <MenuItem key={hour} value={hour}>{hour}</MenuItem>)
                                        }
                                    </TextField>
                                )}
                            />
                        </Grid>
                    ):null}
                </Grid>
            </Container>
        </>
    );
}
